import { useEffect, useState } from "react";
import { logger } from "cayo.ui";
import { endpoints } from "@cayo/shared/services/endpoints.service";
import { Manifest } from "@cayo/shared/types/manifest";
import { urlUtils } from "@cayo/shared/utils/url";

let cachedManifest: Manifest | null = null;
const log = logger.getLogger("useManifest");

export const isProfileDisabled = () =>
  (cachedManifest?.client_config?.features &&
    cachedManifest.client_config?.features["profile"] === "disabled") ??
  false;

export const useManifest = () => {
  const [manifest, setManifest] = useState<Manifest | null>(cachedManifest);

  useEffect(() => {
    if (cachedManifest) {
      log.debug("Skip manifest fetching");
      return;
    }

    const fetchManifest = async () => {
      const manifestUrl = urlUtils.buildRelativePath(endpoints.PUBLIC_URL, "/manifest.json");

      log.info("Fetching manifest");
      const response = await fetch(manifestUrl);
      const data = await response.json();

      log.info("Manifest", data);
      cachedManifest = data;
      setManifest(data);
    };

    fetchManifest();
  }, []);

  return manifest;
};
